import React from "react";

const YextIcon = () => <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_11718_133)">
    <circle cx="24" cy="24" r="23.5" stroke="#E0E0E0" />
    <g clipPath="url(#clip1_11718_133)">
      <path fillRule="evenodd" clipRule="evenodd" d="M24 39C15.7046 39 9 32.2954 9 24C9 15.7046 15.7046 9 24 9C32.2954 9 39 15.7046 39 24C39 32.2954 32.2954 39 24 39ZM37.8 24C37.8 16.3678 31.6322 10.2 24 10.2C16.3678 10.2 10.2 16.3678 10.2 24C10.2 31.6322 16.3678 37.8 24 37.8C31.6322 37.8 37.8 31.6322 37.8 24ZM24.45 24.45H31.05V25.65H28.35V31.05H27.15V25.65H24.45V24.45ZM23.7 25.1487L21.0987 27.75L23.7 30.3513L22.8513 31.2L20.25 28.5987L17.6487 31.2L16.8 30.3513L19.4013 27.75L16.8 25.1487L17.6487 24.3L20.25 26.9013L22.8513 24.3L23.7 25.1487ZM24.3 20.175C24.3 18.3118 25.8099 16.8 27.675 16.8C28.8632 16.8 29.9053 17.4138 30.5072 18.3414L26.7197 22.1289C27.0079 22.2711 27.3316 22.35 27.675 22.35C28.877 22.35 29.85 21.377 29.85 20.175H31.05C31.05 22.0382 29.5382 23.55 27.675 23.55C25.8099 23.55 24.3 22.0382 24.3 20.175ZM25.5 20.175C25.5 20.5974 25.6204 20.9901 25.8276 21.3237L28.8237 18.3276C28.4901 18.1204 28.0974 18 27.675 18C26.473 18 25.5 18.973 25.5 20.175ZM22.7803 16.8L23.7 17.5717L20.85 20.9684V23.55H19.65V20.9684L16.8 17.5717L17.7197 16.8L20.25 19.8158L22.7803 16.8Z" fill="black" />
    </g>
  </g>
  <defs>
    <clipPath id="clip0_11718_133">
      <rect width="48" height="48" fill="white" />
    </clipPath>
    <clipPath id="clip1_11718_133">
      <rect width="30" height="30" fill="white" transform="translate(9 9)" />
    </clipPath>
  </defs>
</svg>;

export default YextIcon;
